<template>
  <mdb-container fluid>

      
      <mdb-modal cascade :show="newWindowsTicket" @close="newWindowsTicket = false">
        
        <mdb-modal-header class="light-blue darken-3 text-white">
          <h4 class><i class="fas fa-edit"></i> ارسال تیکت جدید</h4>
        </mdb-modal-header>
        
        <mdb-modal-body>
          <mdb-input
            class="grey-text rtl"
            type="text"
            label="عنوان درخواست"
            icon="envelope"
            v-model="form.Title"
          />
          <mdb-select
            v-model="levelOptions"
            placeholder="اهمیت درخواست"
            label="اهمیت درخواست"
            :required="true"
            @change="selectLevel"
          />
          <mdb-select
            v-model="departmentOptions"
            placeholder="دپارتمان"
            label="دپارتمان"
            :required="true"
            @change="selectDepartment"
          />
          <mdb-select
            v-model="subDepartmentOptions"
            placeholder="نوع درخواست"
            label="نوع درخواست"
            :required="true"
            @change="selectSubDepartment"
          />
          
          <mdb-select
            v-model="serviceOptions"
            placeholder="سرویس ها"
            label="انتخاب سرویس "
            :required="true"
            v-show="form.Department == 4"
            @change="selectService"
          />
          <mdb-textarea
            class="grey-text rtl"
            :rows="4"
            v-model="form.Body"
            label="پیام شما"
            icon="pencil-alt"
          />
          <br />
          <div class="d-flex flex-row">
            <div class="col-12 mt-2">
              <mdb-progress v-if="posting"  class="my-3" :value="uploadProgress" striped animated></mdb-progress>
            </div>
          </div>
          <div>
            <mdb-chip v-for="file in files" 
              v-bind:key="file.name" 
              @closeChip="removeFile(file)"
              color="lighten-4" close
              >{{file.name}}</mdb-chip>

            <mdb-file-input floating lg icon="paperclip" multiple
              @getValue="selectFile" btnColor="primary" class="attach" />
          </div>
          

        </mdb-modal-body>

        <mdb-modal-footer class="justify-content-center">
          <mdb-btn color="info"
            @click="sendTicket" 
            icon="paper-plane" 
            :disabled="posting"
            iconLeft>ارسال</mdb-btn>
        </mdb-modal-footer>
      </mdb-modal>


    <div class="row pt-5 pb-3">
      <div class="col-md-3 mx-auto mb-4">
        <div class="card pt-0 card-cascade narrower">
          
          <div
            class="view view-cascade gradient-card-header mdb-color lighten-3"
          >
            <h5 class="mb-0 font-weight-bold">ابزار</h5>
          </div>
          
          <div class="card-body">


            <div class="mt-2">
              <small>بخش ها:</small>

              <ul class="striped list-unstyled" 
                  v-if="ticketGroups!=null">

                <li class="hover filter"
                  v-for="ticketGroup in ticketGroups" 
                  v-bind:key="ticketGroup.Name"
                  v-if="ticketGroup!=null"
                  @click="getTicketgroup(ticketGroup)">

                  <span class="badge bg-danger float-left" v-show="ticketGroup.CountNew>0" v-text="ticketGroup.CountNew"></span>
                  <span class="badge bg-primary" v-text="(ticketGroup.Tickets? ticketGroup.Tickets.length:0)"></span>&nbsp;
                  <span v-text="ticketGroup.Display"></span>
                  
                </li>
                
              </ul>
            </div>
            
            
            <button
              type="button"
              class="btn btn-primary btn-lg btn-block"
              data-toggle="modal"
              data-target="#modal-support"
              @click="newWindowsTicket = true"
            >
              <i class="fas fa-plus left"></i> تیکت جدید
            </button>
          </div>
          
        </div>
      </div>

      <div class="col-md-8 mx-auto white z-depth-1 mb-4">
        <div class="row">
          <div class="col-sm-6 col-md-9 py-4 px-3">
            <h4 class="h4-responsive">تیکت ها</h4>
          </div>
          <!-- <div class="col-sm-6 col-md-3">
            <div class="md-form">
              <input
                placeholder="Search..."
                type="text"
                id="form5"
                class="form-control"
              />
            </div>
          </div> -->
        </div>

        <div class="row">
          <div class="col-md-12 pb-3">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>دپارتمان</th>
                    <th>عنوان</th>
                    <th>آخرین بروزرسانی</th>
                  </tr>
                </thead>
                <tbody>

                  <tr
                    class="hover"
                    v-for="ticket in ticketGroup.Tickets" 
                    v-bind:key="ticket.TicketId" @click="showTicket(ticket)">                    
                    <td>
                      <div :class="'avatar-placeholder darken-3 '+(ticket.Level==1?'green':(ticket.Level==2?'yellow':'red'))">
                        <i v-show="!ticket.Seen" class="fas fa-check"></i>
                        <i v-show="ticket.Seen" class="fas fa-check-double"></i>
                      </div>
                      <span class="department-name" v-text="ticket.DepartmentName"></span>
                    </td>
                    <td v-text="ticket.Title"></td>
                    <td>
                      <span class="grey-text">
                        <small><i class="far fa-clock"></i> <span v-text="ticket.LastUpdate"></span> </small></span>
                    </td>
                  </tr>

                </tbody>
              </table>
            </div>

            <!-- <mdb-dropdown dropup>
              <mdb-dropdown-toggle slot="toggle" color="primary"
                >Selected</mdb-dropdown-toggle
              >
              <mdb-dropdown-menu dropup>
                <mdb-dropdown-item>Remove</mdb-dropdown-item>
                <mdb-dropdown-item>Mark as read</mdb-dropdown-item>
                <mdb-dropdown-item>Archive</mdb-dropdown-item>
              </mdb-dropdown-menu>
            </mdb-dropdown> -->
          </div>
        </div>
      </div>
      <!-- /.Second column -->
    </div>
    <!-- /.First row -->
  </mdb-container>
</template>

<script>
import {
  mdbContainer,
  mdbDropdown,
  mdbDropdownToggle,
  mdbDropdownMenu,
  mdbDropdownItem,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbIcon,
  mdbInput,
  mdbTextarea,
  mdbBtn,
  mdbSelect,
  mdbFileInput,
    mdbChip,
    mdbProgress ,
    mdbProgressBar
} from "mdbvue";
import crmApi from "@/api/crmApi";
import serviceApi from "@/api/serviceApi";

export default {
  name: "Support",
  components: {
    mdbContainer,
    mdbDropdown,
    mdbDropdownToggle,
    mdbDropdownMenu,
    mdbDropdownItem,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbIcon,
    mdbInput,
    mdbTextarea,
    mdbBtn,
    mdbSelect,
  mdbFileInput,
    mdbChip,
    mdbProgress ,
    mdbProgressBar
  },
  data() {
    return {
      ticketGroups:null,
      ticketGroup: {},
      newWindowsTicket: false,
      form: {
        Title: null,
        Body: null,
        Level: null,
        Type: null,
        Department: null,
        ServiceId: null,
        Files: [],
      },
      levelOptions: [],
      departmentOptions: [],
      subDepartmentOptions: [],
      files: [],
      posting: false,
      services: [],
      uploadProgress: 0,

      allowedFormats: {
        
        // ویدیو
        "video/mp4": ".mp4",
        // تصاویر
        "image/bmp": ".bmp",
        "image/gif": ".gif",
        "image/jpeg": ".jpg",
        "image/png": ".png",
        "image/tiff": ".tiff",
        "image/x-icon": ".ico",
        "image/svg+xml": ".svg",
        "image/webp": ".webp",
        // اسناد
        "application/msword": ".doc",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": ".docx",
        "application/pdf": ".pdf",
        "application/vnd.ms-powerpoint": ".ppt",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": ".pptx",
        "application/rtf": ".rtf",
        // اکسل
        "application/vnd.ms-excel": ".xls",
        "application/x-msexcel": ".xls",
        "application/ms-excel": ".xls",
        "application/msexcel": ".xls",
        "application/x-excel": ".xls",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ".xlsx",
        // فایل‌های متنی
        "text/plain": ".txt",
        // فایل‌های فشرده (ZIP و RAR)
        "application/zip": ".zip",
        "application/zip-compressed": ".zip",
        "application/x-zip-compressed": ".zip",
        "multipart/x-zip": ".zip",
        "application/vnd.rar": ".rar",
        "application/octet-stream": ".rar",
        "application/x-rar-compressed": ".rar",
        "application/x-rar": ".rar",
        // فایل‌های صوتی
        "audio/mpeg": ".mp3",
        "audio/wav": ".wav",
        "audio/x-wav": ".wav",
      }
    };
  },  
  methods: {
    getTicketgroup(ticketGroup){
      this.ticketGroup = ticketGroup;
    },
    showTicket(ticket){
      this.$router.push({name: 'Ticket', params: { ticketId: ticket.TicketId }});
    },
    selectDepartment(value,text){
      // console.log(value,text);
      this.form.Department = value;
      this.subDepartmentOptions = [];
      if(value == 0){
        this.subDepartmentOptions = [
          { text: "درخواست عمومی جدید", value: "40",selected:false },
        ];
      } else if(value == 1){
        this.subDepartmentOptions = [
          { text: "قرار داد جدید", value: "10",selected:false },
          { text: "امور قرار داد وحقوقیتمدید قرار داد", value: "11",selected:false },
          { text: "پایان قرار داد", value: "12",selected:false },
        ];
      } else if(value == 2){
        this.subDepartmentOptions = [
          { text: "ثبت فیش واریز", value: "20",selected:false },
          { text: "درخواست برداشت", value: "21",selected:false },
          { text: "درخواست فاکتور رسمی", value: "22",selected:false },
        ];
      } else if(value == 3){
        this.subDepartmentOptions = [
          { text: "درخواست جدید", value: "30",selected:false },
          { text: "پیگیری", value: "31",selected:false },
          { text: "شکایت", value: "32",selected:false },
          { text: "استخدام", value: "33",selected:false },
        ];
      } else if(value == 4){
        this.subDepartmentOptions = [
          { text: "درخواست جدید", value: "40",selected:false },
        ];
      }else if(value == 5){
        this.subDepartmentOptions = [
          { text: "درخواست جدید", value: "50",selected:false },
        ];
      }
      
    },
    selectLevel(value){
      this.form.Level = value;
    },
    selectSubDepartment(value){
      this.form.Type = value;
    },
    selectService(value,text){
      this.form.ServiceId = value;
    },
    selectFile(files) {
      if (files.length > 0) {
        
        for(var i = 0; i < files.length; i++){

          if (files[i]) {
            const mimeType = files[i].type;
            const extension = this.allowedFormats[mimeType];
            console.log(mimeType);

            if (extension) {
              // Optionally check if the file name matches the expected extension
              if (files[i].name.endsWith(extension)) {
                
                this.$toastr.s( "پیوست "+files[i].name+" با موفقیت انتخاب شد.","پیوست فایل");
                this.files.push(files[i]);
              } else {
                
                this.$toastr.e("پیوست "+files[i].name+" دارای فرمت قابل قبول نیست.","پیوست فایل");
              }
            } else {
              
              this.$toastr.e("پیوست "+files[i].name+" دارای فرمت قابل قبول نیست.","پیوست فایل");
            }
          }
          
        }
        // this.files = files;
      } 
    },
    sendTicket(){
      // console.log(this.form.Department);
      if((this.form.Department == null || !this.form.Department) && this.form.Department != 0){
        this.$toastr.w( "لطفاً دپارتمان را انتخاب کنید.","ارسال تیکت");
        return;
      }

      if(this.form.Level == null || !this.form.Level){
        this.$toastr.w( "لطفاً اهمیت موضوع را انتخاب کنید.","ارسال تیکت");
        return;
      }
      
      if(this.form.Type == null || !this.form.Type){
        this.$toastr.w( "لطفاً موضوع درخواستی را انتخاب کنید.","ارسال تیکت");
        return;
      }
      
      if(this.form.Department == 4){
        if(this.form.ServiceId == null || !this.form.ServiceId){
          this.$toastr.w( "لطفاً سرویس را انتخاب کنید.","ارسال تیکت");
          return;
        }
      }

      if(this.form.Body == null || !this.form.Body){
        this.$toastr.w( "لطفاً پیام خود را وارد کنید.","ارسال تیکت");
        return;
      }

      let formData = new FormData();
      for(var i=0; i< this.files.length; i++){
        formData.append('Files', this.files[i]);
      }
      formData.append('Title', this.form.Title);
      formData.append('Body', this.form.Body);
      formData.append('Level', this.form.Level);
      formData.append('Type', this.form.Type);
      formData.append('Department', this.form.Department);
      if(this.form.ServiceId!=null){
        formData.append('ServiceId', this.form.ServiceId);
      }

      crmApi
        .sendTicket(formData, (progressEvent) => {
          if (progressEvent.lengthComputable) {
            this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          }
        })
        .then(({ data }) => {
          if (data.Status === 1) {
            this.Form = {
              Title: null,
              Body: null,
              Level: null,
              Type: null,
              Department: null,
              ServiceId: null,
              Files: [],
            };

            this.newWindowsTicket = false;
            this.posting = false;
            this.$toastr.s("پیام شما با موفقیت ارسال شد.","تیکت");

            this.$router.push({name: 'Ticket', params: { ticketId: data.Data }});
            

          } else {
            this.message = data.Message;
            this.posting = false;
            // console.log(data);
            this.$toastr.e( data.Message,"تیکت");            
          }
        },
        (r) => {

          var message = r.response.data.errors;
          this.posting = false;
          this.message = null;

          if(message.hasOwnProperty("Body")){
            this.message = message.Body;
          }

          if(message.hasOwnProperty("Files")){
            this.message = message.CaptchaInputText;
          }
          
          this.$toastr.e("ارسال تیکت", "خطا در بارگذاری. لطفاً فایل مناسب را انتخاب کنید.");
        }
      );

    }
  },
  mounted() {
    // console.log("mounted");
    let type = this.$route.params.type;
    switch(type){
      case 'new':
        this.newWindowsTicket = true;
        break;
    }

    this.ticketGroups = this.$store.state.ticketGroups;

    this.levelOptions = [
      { text: "کم", value: "1",selected:false },
      { text: "متوسط", value: "2",selected:false },
      { text: "زیاد", value: "3",selected:false }
    ];
    
    this.departmentOptions = [];
    
    this.subDepartmentOptions = [];

    this.subDepartmentOptions = [
          { text: "قرار داد جدید", value: "10",selected:false },
          { text: "امور قرار داد وحقوقیتمدید قرار داد", value: "11",selected:false },
          { text: "پایان قرار داد", value: "12",selected:false },
        ];
    
    crmApi.getTickets().then(
      ({ data }) => {
        this.$store.state.ticketGroups = data;
        this.ticketGroups = this.$store.state.ticketGroups;
        this.getTicketgroup(this.ticketGroups[0]);

        for(var i = 0; i < this.ticketGroups.length; i++){
          this.departmentOptions.push({ text: this.ticketGroups[i].Display, value: this.ticketGroups[i].Value,selected:false });
        }
      },
      (r) => {}
    );

    
    serviceApi.getServiceList().then(
      ({ data }) => {
        this.$store.state.services = data;
        this.services = this.$store.state.services;
      },
      (r) => {}
    );
    
  },
  computed:{
    serviceOptions: function(){
        var serviceOptions = [];    
        for(var i =0;i<this.services.length;i++){
          serviceOptions.push({ text: this.services[i].Name, value: this.services[i].ServiceId,selected:false })
        }
        console.log('serviceOptions : '+serviceOptions.length);
        return serviceOptions;
    }
  },
  watch: {
    "$route.params": {
      handler(newValue) {

        let type = this.$route.params.type;
        switch(type){
          case 'new':
            this.newWindowsTicket = true;
            break;
        }
      },
      immediate: true,
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.avatar-placeholder {
  height: 32px;
  color: rgba(255, 255, 255, 0.75);
  text-align: center;
  line-height: 32px;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: default;
}
.avatar-32,
.avatar-placeholder {
  width: 32px;
  margin-right: 8px;
  display: inline-block;
}
.avatar-32 {
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
.avatar-32,
.avatar-placeholder {
  width: 32px;
  margin-right: 8px;
  display: inline-block;
}

.card.card-cascade .view.gradient-card-header {
  padding: 1.1rem 1rem;
}

.card.card-cascade .view {
  box-shadow: 0 5px 12px 0 rgba(0, 0, 0, 0.2), 0 2px 8px 0 rgba(0, 0, 0, 0.19);
}

.card.card-cascade.narrower .view.view-cascade {
  margin-top: -1.25rem;
  margin-right: 4%;
  margin-left: 4%;
}
</style>
